import React from "react";

const Spinner = () => {
  return (
    <div className="spinner-border" role="status" style={{position: 'absolute', top:'50%', right:'50%'}}>
  <span className="visually-hidden">Loading...</span>
</div>

  );
};

export default Spinner;
